const resources = {}; // store all etag resources within this object for later usage
const etags = {}; // store all etags within this object for later usage

module.exports = {

    /**
     * returns a resource identified by etag if possible or false otherwise.
     *
     * @param etag          etag given by the server response header
     * @return {boolean|*}
     */
    getResource: function(etag){
        if(resources[etag]){
            return resources[etag]
        }

        return false
    },

    /**
     * sets a resource identified by etag within the resource storage.
     *
     * @param etag          etag given by the server response header
     * @param resource      mixed - anything you like to store locally ;-)
     */
    setResource: function(etag, resource){
        delete (resource || {}).updateClientStorage
        delete ((((resource || {}).children || {})[(resource || {}).childLayoutIndex || 0] || {}).model || {}).updateClientStorage
        resources[etag] = resource
    },

    /**
     * check if etag is present and has been issued by the fec-server and not anyone else.
     * returns the valid etag or false otherwise.
     *
     * @param etag          etag given by the server response header
     * @return {boolean|string}
     */
    returnETagIfValid: function(etag){
        if(String(etag || '').match(/^(W[/]"?)?fec_/) !== null){
            return etag
        }

        return false
    },

    /**
     * get an etag identified by the given parameters or false otherwise.
     *
     * @param resourceHash      string - hash to identify the etag
     * @return {boolean|string}
     */
    getETag: function(resourceHash){

        if(etags[resourceHash]){
            return etags[resourceHash]
        }

        return false
    },

    /**
     * stores a new etag for the given parameters.
     *
     * @param resourceHash      string - hash to identify the etag
     * @param etag              string - etag
     */
    setETag: function(resourceHash, etag){
        etags[resourceHash] = etag
    },
}